<template>
  <div class="iframe-modal">
    <a-modal
      :title="isComplete ? '该服务关联了多条核名记录' : '该服务关联了多条核名记录，需要全部确认完成'"
      :visible="nameVerificationReportVisible"
      @cancel="nameVerificationReportVisible = false"
      :footer="false"
      width="680px"
      centered
    >
      <a-table rowKey="id" :pagination="false" :columns="columns" :data-source="workRelWorkOrderList">
        <span slot="recordStatus" slot-scope="text">{{ recordStatusMap[text] }}</span>
        <span class="operate-btn" slot="operate" slot-scope="text, record">
          <a-button type="link" @click="goReportPage(record)">{{ isComplete ? '查看报告' : '确认核名报告' }}</a-button>
        </span>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
export default {
  props: {
    currRow: Object | '',
    workRelWorkOrderList: Array,
  },
  data() {
    return {
      //多条核名报告
      nameVerificationReportVisible: false,
      columns: [
        {
          title: '商标名称',
          dataIndex: 'trademarkName',
        },
        {
          title: '商标类别',
          dataIndex: 'categoryNum',
        },
        {
          title: '核名记录状态',
          dataIndex: 'recordStatus',
          scopedSlots: { customRender: 'recordStatus' },
        },
        {
          title: '操作',
          dataIndex: 'operate',
          scopedSlots: { customRender: 'operate' },
        },
      ],
      recordStatusMap: {
        WAIT_CONFIRM: '待确认',
        RECHECK_WAIT_CONFIRM: '已复核待确认',
        AUDIT_WAIT_CONFIRM: '已终审待确认',
        COMPLETE: '已完成',
      },
      isComplete: false,
    };
  },
  watch: {
    workRelWorkOrderList(val) {
      this.isComplete = val.filter((ele) => ele.recordStatus === 'COMPLETE').length;
    },
  },
  methods: {
    goReportPage(workOrder) {
      let reportVOList = workOrder.trademarkSearchRecordReportVOList;
      reportVOList = reportVOList[reportVOList.length - 1];
      let routeUrl = this.$router.resolve({
        path: '/trademarkNameReviewReport',
        query: {
          recordId: workOrder.id,
          linkId: reportVOList.id,
          workId: this.currRow.workOrderId,
          servicesId: this.currRow.servicesId,
        },
      });
      this.nameVerificationReportVisible = false;
      window.open(routeUrl.href, '_blank');
    },
  },
};
</script>
<style lang="less" scoped>
.operate-btn {
  button {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/NameVerificationReportPop.vue